import {
    Component,
    Input,
    forwardRef,
    OnInit,
    Output,
    EventEmitter, TemplateRef,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    AbstractControl,
    ControlContainer,
    FormGroupDirective,
} from '@angular/forms';
import { ReactiveFormsService } from '../../providers';

@Component({
    selector: 'roblex-input-form-select',
    templateUrl: './input-form-select.component.html',
    styleUrls: ['./input-form-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => InputFormSelectComponent),
        },
    ],
})
export class InputFormSelectComponent implements OnInit, ControlValueAccessor {
    /**
     * Control  of input form field component
     */
    control: AbstractControl;
    /**
     * Input  of input form field component
     */
    @Input() appearance: 'standard' | 'fill' | 'outline' = 'outline';
    /**
     * Input  of input form field component
     */
    @Input() formControlName: string;
    /**
     * Input flatten text of form select component
     */
    @Input() flattenText: boolean = false;
    /**
     * Input  of input field component
     */
    @Input() disabled = false;
    /**
     * Input  of input form select component
     */
    @Input() displayKey: string = 'id';
    /**
     * Input  of input form select component
     */
    @Input() displayValue: string = 'name';
    /**
     * Input display function of input form select component
     */
    @Input() displayFn: (item?: any) => any;
    /**
     * Input display imagen functions of input form select component
     */
    @Input() displayImagenFn: (item?: any) => any;
    /**
     * Input  of input form select component
     */
    @Input('value') val: string;
    /**
     * Input  of input form select component
     */
    @Input() label: string;
    /**
     * Input  of input form select component
     */
    @Input() data: any[] = [];
    /**
     * Input template legend of input form select component
     */
    @Input() templateLegend: TemplateRef<any>;
    /**
     * Input icon left of input form select component
     */
    @Input() iconLeft: string;
    // /**
    //  * Input icon right of input form select component
    //  */
    // @Input() iconRight: string;
    /**
     * Output suffix of input form select component
     */
    @Output() suffix: EventEmitter<any> = new EventEmitter();
    /**
     * Output  of input form select component
     */
    @Output() selectChange: EventEmitter<any> = new EventEmitter();
    /**
     * Determines whether change on
     */
    onChange: any = () => {};
    /**
     * Determines whether touched on
     */
    onTouched: any = () => {};
    /**
     * Gets value
     */
    get value() {
        return this.val;
    }
    /**
     * Sets value
     */
    set value(val: any) {
        this.val = val;
        this.onChange(val);
        // this.onTouched();
    }
    /**
     * Gets form
     */
    get form() {
        return this.controlContainer.formDirective
            ? (this.controlContainer.formDirective as FormGroupDirective).form
            : null;
    }
    /**
     * Creates an instance of input form field component.
     * @param controlContainer ControlContainer
     */
    constructor(private controlContainer: ControlContainer) {}
    /**
     * on init
     */
    ngOnInit(): void {
        this.control = this.form.get(this.formControlName);
    }
    /**
     * Gets error message
     */
    getErrorMessage() {
        if (this.control) {
            return ReactiveFormsService.errorMessage(this.control);
        }
        return null;
    }
    /**
     * Determines whether change event on
     * @param value
     */
    onChangeEvent(value: any) {
        this.selectChange.emit(value);
        this.writeValue(value != undefined ? value : null);
    }
    /**
     * Determines whether blur event on
     */
    onBlurEvent() {
        if (this.control) {
            this.control.markAsTouched();
        }
    }
    /**
     * Registers on change
     * @param fn any
     */
    registerOnChange(fn: any) {
        this.onChange = fn;
    }
    /**
     * Registers on touched
     * @param fn any
     */
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }
    /**
     * Sets disabled state
     * @param isDisabled boolean
     */
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
    /**
     * Writes value
     * @param value any
     */
    writeValue(value: any) {
        this.value = value;
    }
}
